import React, { useEffect, useRef, useState } from "react";
import { useFillHeight } from "../lib/useFillHeight";
import CollapseBar, { BarTitle } from "../components/CollapseBar";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import ConfirmDialog from "../components/ConfirmDialog";
import { Plus, Trash2, FileDown, FileText } from "lucide-react";
import { trUpper } from "../lib/mw";
import { toast } from "sonner";

function buildHtml(title, r) {
  const d = r.data || {};
  const bar = (d.baremler || []).map(
    (b) => `<tr><td>${b.il || "-"}</td><td>${b.desi_kg || "-"}</td><td style="text-align:right">${b.tutar || "-"}</td></tr>`
  ).join("");
  return `
  <div class="brand">MWCRMPRO</div>
  <h1>${title} #${r.id}</h1>
  <div class="muted">DÜZENLEME TARİHİ: ${d.tarih || "-"} &nbsp;·&nbsp; BİTİŞ: ${d.bitis_tarihi || "-"}</div>
  <table class="kv">
    <tr><td class="k">MÜŞTERİ</td><td>${d.musteri || d.firma || "-"}</td></tr>
    <tr><td class="k">YETKİLİ</td><td>${d.yetkili || "-"}</td></tr>
    <tr><td class="k">DURUM</td><td>${d.durum || "-"}</td></tr>
  </table>
  ${d.serbest_metin ? `<div class="section"><h3>SÖZLEŞME METNİ</h3><div class="free">${String(d.serbest_metin).replace(/\n/g, "<br>")}</div></div>` : ""}
  ${bar ? `<div class="section"><h3>FİYAT BAREMLERİ (İL / DESİ-KG / TUTAR)</h3><table class="bar"><thead><tr><th>İL</th><th>DESİ / KG</th><th style="text-align:right">TUTAR (₺)</th></tr></thead><tbody>${bar}</tbody></table></div>` : ""}
  <div class="sign">
    <div class="box"><div class="st">TAŞIYICI (${d.tasiyici || "MWCRMPRO"})</div><div class="line"></div><div class="lbl">KAŞE / İMZA</div></div>
    <div class="box"><div class="st">TAŞITAN (${d.tasitan || d.musteri || "-"})</div><div class="line"></div><div class="lbl">KAŞE / İMZA</div></div>
  </div>`;
}
const DOC_CSS = `body{font-family:Arial,sans-serif;padding:40px;color:#0f172a}h1{font-size:22px;margin:0 0 4px}h3{font-size:14px;margin:18px 0 8px;color:#1e293b}.muted{color:#64748b;font-size:12px;margin-bottom:18px}table{width:100%;border-collapse:collapse}table.kv td{padding:8px 10px;border:1px solid #e2e8f0;font-size:13px}td.k{background:#f8fafc;font-weight:700;width:30%}table.bar th,table.bar td{padding:8px 10px;border:1px solid #e2e8f0;font-size:13px}table.bar th{background:#f1f5f9}.brand{font-weight:800;color:#2563eb;font-size:18px}.free{font-size:13px;line-height:1.6;white-space:pre-wrap}.section{margin-top:12px}.sign{display:flex;gap:40px;margin-top:48px}.box{flex:1}.st{font-weight:700;font-size:12px;margin-bottom:40px}.line{border-top:1px solid #0f172a}.lbl{font-size:11px;color:#64748b;margin-top:4px}`;

function printRecord(title, r) {
  const win = window.open("", "_blank", "width=820,height=1000");
  if (!win) { toast.error("POP-UP ENGELLENDİ"); return; }
  win.document.write(`<html><head><title>${title} #${r.id}</title><style>${DOC_CSS}</style></head><body>${buildHtml(title, r)}<script>window.onload=function(){window.print();}</script></body></html>`);
  win.document.close();
}
function downloadWord(title, r) {
  const html = `<html xmlns:w="urn:schemas-microsoft-com:office:word"><head><meta charset="utf-8"><style>${DOC_CSS}</style></head><body>${buildHtml(title, r)}</body></html>`;
  const blob = new Blob(["\ufeff", html], { type: "application/msword" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a"); a.href = url; a.download = `${title}_${r.id}.doc`; a.click();
  URL.revokeObjectURL(url);
}

export default function RecordPage({ title, endpoint, testid }) {
  const tableBoxRef = useRef(null);
  useFillHeight(tableBoxRef);
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ baremler: [] });
  const [confirm, setConfirm] = useState(null);
  const [customers, setCustomers] = useState([]);

  const load = () => api.get(`/${endpoint}`).then((r) => setRows(r.data));
  useEffect(() => { load(); }, [endpoint]);
  useEffect(() => { api.get("/customers", { params: { page: 1, page_size: 0 }, silent: true }).then((r) => setCustomers(r.data.items || [])).catch(() => {}); }, []);

  const addBarem = () => setForm((f) => ({ ...f, baremler: [...(f.baremler || []), { il: "", desi_kg: "", tutar: "" }] }));
  const setBarem = (i, k, v) => setForm((f) => ({ ...f, baremler: f.baremler.map((b, idx) => (idx === i ? { ...b, [k]: k === "tutar" || k === "desi_kg" ? v : trUpper(v) } : b)) }));
  const delBarem = (i) => setForm((f) => ({ ...f, baremler: f.baremler.filter((_, idx) => idx !== i) }));

  const save = async () => {
    if (!form.musteri) { toast.error("MÜŞTERİ GEREKLİ"); return; }
    await api.post(`/${endpoint}`, { data: { ...form, firma: form.musteri, tarih: form.tarih || new Date().toISOString().slice(0, 10) } });
    toast.success("KAYDEDİLDİ");
    setOpen(false); setForm({ baremler: [] }); load();
  };
  const del = async () => { await api.delete(`/${endpoint}/${confirm}`); toast.success("SİLİNDİ"); setConfirm(null); load(); };
  const openNew = () => { setForm({ baremler: [] }); setOpen(true); };

  return (
    <div className="mw-fade-up space-y-4">
      <BarTitle><div className="flex items-center justify-between">
        <div>
          <h1 className="font-head text-3xl font-bold tracking-tight text-white">{title}</h1>
          <p className="text-sm text-slate-400">{rows.length} KAYIT · MÜŞTERİ · TARİH · BAREM · PDF / WORD</p>
        </div>
        <CollapseBar id="recordpage-actions" label="İŞLEMLER" className="flex-1 justify-end">
        <Button data-testid={`${testid}-add`} onClick={openNew} className="bg-blue-600 text-white hover:bg-blue-700">
          <Plus className="mr-1 h-4 w-4" /> YENİ KAYIT
        </Button>
        </CollapseBar>
      </div></BarTitle>

      <div ref={tableBoxRef} className="overflow-auto rounded-xl border border-slate-800 bg-slate-900">
        <table className="mw-table w-full text-sm">
          <thead className="sticky top-0 z-10 bg-slate-900">
            <tr className="border-b border-slate-800 bg-slate-800/50 text-left text-xs uppercase tracking-wider text-slate-400">
              <th className="px-4 py-3">ID</th><th className="px-4 py-3">TARİH</th><th className="px-4 py-3">BİTİŞ</th><th className="px-4 py-3">MÜŞTERİ</th>
              <th className="px-4 py-3">BAREM</th><th className="px-4 py-3">DURUM</th><th className="px-4 py-3 text-right">İŞLEM</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-slate-500">KAYIT YOK</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-slate-800/60 hover:bg-slate-800/40">
                <td className="px-4 py-2.5 font-mono text-slate-500">#{r.id}</td>
                <td className="px-4 py-2.5 text-slate-300">{r.data.tarih}</td>
                <td className="px-4 py-2.5 text-slate-400">{r.data.bitis_tarihi || "-"}</td>
                <td className="px-4 py-2.5 text-slate-200">{r.data.musteri || r.data.firma}</td>
                <td className="px-4 py-2.5 text-slate-400">{(r.data.baremler || []).length} SATIR</td>
                <td className="px-4 py-2.5 text-slate-300">{r.data.durum || "-"}</td>
                <td className="px-4 py-2.5 text-right">
                  <div className="flex items-center justify-end gap-1">
                    <button data-testid={`${testid}-pdf-${r.id}`} onClick={() => printRecord(title, r)} className="rounded-md p-1.5 text-slate-400 hover:bg-slate-700 hover:text-blue-400" title="PDF / YAZDIR"><FileDown className="h-4 w-4" /></button>
                    <button data-testid={`${testid}-word-${r.id}`} onClick={() => downloadWord(title, r)} className="rounded-md p-1.5 text-slate-400 hover:bg-slate-700 hover:text-sky-400" title="WORD İNDİR"><FileText className="h-4 w-4" /></button>
                    <button onClick={() => setConfirm(r.id)} className="rounded-md p-1.5 text-slate-400 hover:bg-slate-700 hover:text-rose-400"><Trash2 className="h-4 w-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[92vh] max-w-2xl overflow-y-auto border-slate-700 bg-slate-900 text-slate-100">
          <DialogHeader><DialogTitle className="font-head">YENİ {title}</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div className="space-y-1.5">
              <Label className="text-xs text-slate-400">SÖZLEŞME MÜŞTERİSİ (SİSTEMDEN SEÇ)</Label>
              <Input data-testid={`${testid}-musteri`} list={`${testid}-cust-list`} className="h-10 border-slate-700 bg-slate-800 text-slate-100" value={form.musteri || ""}
                onChange={(e) => {
                  const v = trUpper(e.target.value);
                  const c = customers.find((x) => (x.data.firma || "").toLocaleUpperCase("tr-TR") === v);
                  setForm((f) => ({ ...f, musteri: v, yetkili: c ? c.data.yetkili || f.yetkili : f.yetkili, tasitan: c ? c.data.firma : f.tasitan }));
                }} placeholder="FİRMA ADI YAZ VEYA SEÇ" />
              <datalist id={`${testid}-cust-list`}>{customers.map((c) => <option key={c.id} value={c.data.firma} />)}</datalist>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1.5"><Label className="text-xs text-slate-400">SÖZLEŞME TARİHİ</Label>
                <Input type="date" className="h-10 border-slate-700 bg-slate-800 text-slate-100" value={form.tarih || ""} onChange={(e) => setForm((f) => ({ ...f, tarih: e.target.value }))} /></div>
              <div className="space-y-1.5"><Label className="text-xs text-slate-400">BİTİŞ TARİHİ</Label>
                <Input type="date" className="h-10 border-slate-700 bg-slate-800 text-slate-100" value={form.bitis_tarihi || ""} onChange={(e) => setForm((f) => ({ ...f, bitis_tarihi: e.target.value }))} /></div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1.5"><Label className="text-xs text-slate-400">TAŞIYICI FİRMA</Label>
                <Input className="h-10 border-slate-700 bg-slate-800 text-slate-100" value={form.tasiyici || ""} onChange={(e) => setForm((f) => ({ ...f, tasiyici: trUpper(e.target.value) }))} placeholder="MWCRMPRO" /></div>
              <div className="space-y-1.5"><Label className="text-xs text-slate-400">TAŞITAN FİRMA</Label>
                <Input className="h-10 border-slate-700 bg-slate-800 text-slate-100" value={form.tasitan || ""} onChange={(e) => setForm((f) => ({ ...f, tasitan: trUpper(e.target.value) }))} /></div>
            </div>
            <div className="space-y-1.5"><Label className="text-xs text-slate-400">SERBEST METİN (SÖZLEŞME / TEKLİF METNİ)</Label>
              <Textarea data-testid={`${testid}-metin`} rows={6} className="border-slate-700 bg-slate-800 text-slate-100" value={form.serbest_metin || ""} onChange={(e) => setForm((f) => ({ ...f, serbest_metin: e.target.value }))} placeholder="Serbestçe yazın veya yapıştırın..." /></div>

            <div className="rounded-lg border border-slate-800 p-3">
              <div className="mb-2 flex items-center justify-between">
                <span className="text-xs font-semibold uppercase text-slate-400">FİYAT BAREMLERİ — İL / DESİ-KG / TUTAR</span>
                <Button data-testid={`${testid}-add-barem`} size="sm" onClick={addBarem} className="h-7 bg-emerald-600 text-white hover:bg-emerald-700"><Plus className="mr-1 h-3.5 w-3.5" /> BAREM EKLE</Button>
              </div>
              <div className="space-y-2">
                {(form.baremler || []).length === 0 && <div className="py-2 text-center text-xs text-slate-500">BAREM YOK</div>}
                {(form.baremler || []).map((b, i) => (
                  <div key={i} className="grid grid-cols-[1fr_1fr_1fr_auto] gap-2">
                    <Input data-testid={`${testid}-barem-il-${i}`} placeholder="İL" value={b.il} onChange={(e) => setBarem(i, "il", e.target.value)} className="h-9 border-slate-700 bg-slate-800 text-slate-100" />
                    <Input placeholder="DESİ / KG" value={b.desi_kg} onChange={(e) => setBarem(i, "desi_kg", e.target.value)} className="h-9 border-slate-700 bg-slate-800 text-slate-100" />
                    <Input placeholder="TUTAR ₺" value={b.tutar} onChange={(e) => setBarem(i, "tutar", e.target.value)} className="h-9 border-slate-700 bg-slate-800 text-slate-100" />
                    <button onClick={() => delBarem(i)} className="rounded-md px-2 text-slate-400 hover:bg-slate-700 hover:text-rose-400"><Trash2 className="h-4 w-4" /></button>
                  </div>
                ))}
              </div>
            </div>

            <div className="space-y-1.5"><Label className="text-xs text-slate-400">DURUM</Label>
              <Input className="h-10 border-slate-700 bg-slate-800 text-slate-100" value={form.durum || ""} onChange={(e) => setForm((f) => ({ ...f, durum: trUpper(e.target.value) }))} placeholder="HAZIRLANIYOR / ONAYLANDI" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} className="border-slate-700 bg-slate-800 text-slate-200">VAZGEÇ</Button>
            <Button data-testid={`${testid}-save`} onClick={save} className="bg-blue-600 text-white hover:bg-blue-700">KAYDET</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <ConfirmDialog open={!!confirm} onOpenChange={(v) => !v && setConfirm(null)} title="KAYIT SİLİNSİN Mİ?" onConfirm={del} />
    </div>
  );
}
